import { Nominal } from "@goodfill/nominal";

export type UserId = Nominal<"UserId">;
export const asUserId = (id: string) => id as unknown as UserId;
